import React from "react";

const columnsToIgnore = ["name", "delete"];

const EditableCell = ({
  value: initialValue,
  row: { index, cell },
  column: { id , width},
  updateCell // This is a custom function that we supplied to our table instance
}) => {

  // console.log(`row object id: ${id} ,cell: ${cell}`);
  // We need to keep and update the state of the cell normally
  const [value, setValue] = React.useState(initialValue);

  const onChange = (e) => {
      setValue(e.target.value);
  };

  // We'll only update the external data when the input is blurred
  const onBlur = () => {
      updateCell(index, id, value);
  };

  // If the initialValue is changed external, sync it up with our state
  React.useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  return !columnsToIgnore.includes(id) ? (
    <div><input type="text" value={value} onChange={onChange} onBlur={onBlur} style={{width:`${width}px`}}/></div>
  ) : cell != null ? (
    cell
  ) : (
    value
  );
};

export default EditableCell;
